import React from 'react'
import axios from 'axios'
import { get } from 'lodash'
import { getToken } from '~/redux/user/tokens'
import Spinner from '~/components/Spinner'
import popup from '../../popup'
import CategoryBox from './CategoryBox'
import './personalization.css'
import Cookies from 'js-cookie'


export default class View extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      recommendationCategories:[],
      loading: true,
      selectedCategories:[],

    }
    this.sendRecommendationCategories = this.sendRecommendationCategories.bind(this)
    this.getUserSelectedCategories = this.getUserSelectedCategories.bind(this)

  }

  getRecommendationCategories = () => ((window.settings.recommendation.recommendCategories && window.settings.recommendation.recommendCategories.length > 0) ? window.settings.recommendation.recommendCategories : [])

  updateRecommendationCategories = (itemSelected, isAddition)=> {
        this.setState((state)=>{
            if(isAddition)
                state.selectedCategories.push(itemSelected);
            else{
                state.selectedCategories.splice(state.selectedCategories.indexOf(itemSelected), 1);
            }
            console.log(state.selectedCategories);
            return state;
        })
  }

  sendRecommendationCategories=()=>{
    return getToken().then(token => {
      return axios({
        method: 'POST',
        url:`${window.settings.apiBaseUrl}/user/recommendations/saveUserRecommendation?site=${window.settings.site}`,
        data: {
          "genreValue": this.state.selectedCategories.join("|"),
          "userIdValue":Cookies.get('vl-user')
        },
        headers: {
          Authorization: token,
          "x-api-key": window.settings.baseAPIKey
        }
      })
      .then(response => {
        console.log(response);
        popup.hide();
      })
      .catch(function (error) {
        console.log(error);
        popup.hide();
      });
    })
  }

  getUserSelectedCategories=()=>{
    return getToken().then(token => {
      return axios({
        method: "GET",
        url:`${window.settings.apiBaseUrl}/user/recommendations/getUserGenres`,
        params: {
          site: window.settings.internalName, userId:Cookies.get('vl-user')
        },
        headers: {
          Authorization: token,
          "x-api-key": window.settings.baseAPIKey
        }
      })
      .then(result => {
        if(result && result.data && result.data.genreValue){
          var selectedGenreArray = result.data.genreValue.split("|");
          this.setState((state)=>{
            state.selectedCategories=[...state.selectedCategories, ...selectedGenreArray]
            console.log(state.selectedCategories);
            return state;
          })
      
        }
      }).catch((error)=>{
        console.log(error);
      });
    })
  }

  componentDidMount() {
    this.setState((state)=>({
        loading:false,
        recommendationCategories: this.getRecommendationCategories()
    }))
    //Code to Get User Selected Previous Recommendations.
    this.getUserSelectedCategories();
  }

  isCategorySelected=(element)=>{
    for(var i=0; i < this.state.selectedCategories.length; i++){
        if(this.state.selectedCategories[i].toLowerCase() === element.toLowerCase())
            return true;
    }
    return false;
  }

  getLocalizedVal =(path) =>{
    const messages = window.settings.genericMessages;
    var chosenLangCode = Cookies.get('userLanguageSelection');
    if(chosenLangCode === "") {
      chosenLangCode = window.settings.languages.default.code
    }
    const localizedVal = get(messages, `localizationMap.${chosenLangCode}.${path}`)
    const defaultVal = get(messages, path)
    return localizedVal || defaultVal
  }

  render() {
    
    if (this.state.loading)
      return (<div className="loading centered"><Spinner/></div>)

    const recommendationSKipClass = this.props.args.recommendedButtonText ?  'recommendationSKip': 'recommendationSubmit'

    return (
      <div className="personalization centered">
        <div className="recommendationHeader">{this.getLocalizedVal('recommendationTitle')}</div>
        <div className="recommendationSubHeader">{this.getLocalizedVal('recommendationSubTitle')}</div>
        
        <div className="personalizationContainer">
            <div class="personalizationRow">
                {this.state.recommendationCategories.length>0 && this.state.recommendationCategories.map((element,position)=>(
                      <CategoryBox key={position} categoryDetail={element} callback={this.updateRecommendationCategories} isSelected={this.isCategorySelected(element.title)}/>
                ))}
            </div>
        </div>

        <button className={`cta secondary ${recommendationSKipClass}`} onClick={(evt)=>{
            this.sendRecommendationCategories();
        }}>{
          this.props.args.recommendedButtonText?"SAVE":"START BROWSING"}</button>
        <div>

        <button className={`cta secondary recommendationSKip`} onClick={(evt)=>{
            popup.hide();
        }} >SKIP</button>

        </div>
      </div>
    )
  }

  alert(txt) {
    this.setState({ error: txt })
  }
}